import type { Escalation } from "../types/game";

const STEPS: { id: Escalation; short: string }[] = [
  { id: "routine",         short: "RTN" },
  { id: "cautious",        short: "CAU" },
  { id: "tense",           short: "TEN" },
  { id: "confrontational", short: "CFR" },
  { id: "combat",          short: "CMB" },
  { id: "critical",        short: "CRT" },
];

interface Props {
  escalation: Escalation;
}

export function EscalationMeter({ escalation }: Props) {
  const idx = STEPS.findIndex(s => s.id === escalation);
  const current = idx >= 0 ? idx : 0;

  return (
    <div className="escalation-meter" role="meter" aria-label="Escalation level" aria-valuenow={current + 1} aria-valuemax={STEPS.length}>
      {STEPS.map((s, i) => {
        let cls = "esc-step";
        if (i < current) cls += " esc-step-past";
        else if (i === current) cls += " esc-step-current";
        else cls += " esc-step-future";
        // Tint past+current red as we climb past confrontational
        if (i <= current && current >= 4) cls += " esc-danger";
        else if (i <= current && current >= 3) cls += " esc-warn";
        return (
          <div key={s.id} className={cls} title={s.id}>
            <span className="esc-step-label">{s.short}</span>
          </div>
        );
      })}
    </div>
  );
}
